import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import ProcessingAnimation from "../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import { get } from "../../../../modules/get.js";
import "./style.css";
import SurveyWindow from "../../../../../../merchant/panel/scripts/shared/SurveyWindow/SurveyWindow.js";
import executeRequest from "../../../../modules/request.js";
export default function SurveyMain(props) {
    const { surveyId } = useParams();
    const [content, setContent] = useState();
    const startTime = useRef(new Date());
    const [closed, setClosed] = useState(false);
    useEffect(() => {
        get(`/api/public/surveys/${surveyId}`).then((res) => {
            if (res.status !== 200)
                return;
            setContent(res.surveyContent);
        });
    }, []);
    if (!content)
        return React.createElement(ProcessingAnimation, null);
    if (closed === true)
        return (React.createElement("div", { className: "survey-page-main-container" },
            React.createElement("div", null,
                "Twoja odpowied\u017A zosta\u0142a zapisana.",
                React.createElement("br", null),
                "Dzi\u0119kujemy!")));
    console.log(surveyId);
    return (React.createElement("div", { className: "survey-page-main-container" },
        React.createElement(SurveyWindow, { onExit: async (results) => {
                if (!results)
                    return;
                await executeRequest(`/api/public/surveys/${surveyId}`, "POST", {
                    steps: results,
                    stepsById: Object.fromEntries(results.map((result) => [result.id, result])),
                    startTime: startTime.current.toISOString(),
                });
                setClosed(true);
            }, survey: {
                surveyContent: content,
                condition: [],
                description: "",
                displayMoment: "nowhere",
                endMessage: "",
                popupPlace: "bottom",
                title: "",
            }, hideExitButtons: true })));
}
